var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerFiveCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C13.4416 2.37963 14.7566 3.13509 15.8108 4.18922C16.8649 5.24335 17.6204 6.55838 18 8",
    stroke: "#D1A97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C13.5488 5.41438 14.5856 6.45125 15 8",
    stroke: "#D1A97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1689 12.0875C13.2772 12.0153 13.4019 11.9714 13.5316 11.9596C13.6612 11.9478 13.7918 11.9686 13.9114 12.02L18.525 14.0871C18.6804 14.1535 18.8102 14.2685 18.8949 14.4149C18.9795 14.5613 19.0145 14.7311 18.9945 14.899C18.8425 16.0349 18.2832 17.0768 17.4205 17.8312C16.5579 18.5855 15.4506 19.0009 14.3046 19C10.776 19 7.39195 17.5983 4.89684 15.1032C2.40174 12.6081 1 9.22396 1 5.69535C0.999125 4.5494 1.41448 3.44212 2.16882 2.57946C2.92315 1.71679 3.96513 1.15745 5.10096 1.00547C5.26887 0.985519 5.43872 1.02049 5.58509 1.10514C5.73146 1.18978 5.84648 1.31956 5.91294 1.47504L7.98005 6.09254C8.03084 6.21113 8.05152 6.34045 8.04025 6.46897C8.02899 6.59749 7.98613 6.72123 7.91548 6.82918L5.82489 9.315C5.75073 9.4269 5.70688 9.55613 5.69762 9.69005C5.68836 9.82397 5.71401 9.958 5.77206 10.079C6.5811 11.7353 8.2931 13.4267 9.95422 14.2279C10.0759 14.2857 10.2105 14.3108 10.3449 14.3007C10.4792 14.2906 10.6086 14.2456 10.7202 14.1702L13.1689 12.0875Z",
    stroke: "#D1A97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFiveCall);
export default __webpack_public_path__ + "static/media/banner-five-call.b8eac587df7857449f5be3f8e249bb5d.svg";
export { ForwardRef as ReactComponent };